import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=005fbc92&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"
import style0 from "./Segment.vue?vue&type=style&index=0&id=005fbc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fbc92",
  null
  
)

export default component.exports